module.exports = __webpack_public_path__ + "img/pan.86229f43.png";